import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, AwaitModules, Grid, LL_H_C, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import './Editor_DiseaseProfile_References.scss';
import { Dialog_Confirmation, FadeScrollWrapper, ICONS } from '@app/styles';
import { ModuleFE_Reference, resolveReferenceDisplay } from '@app/hcs-frontend';
import { StaticLogger, voidFunction } from '@nu-art/ts-common';
import { ModuleFE_DiseaseProfile } from '../../../../../../../_entity.js';
import { Preview_Reference } from '@app/hcs-frontend/ui/_previews/index';
const onReferenceDelete = (profileId, reference) => {
    Dialog_Confirmation.show({
        header: 'Delete Reference',
        content: 'Are you sure you want to delete this reference from the disease profile and all of its connected multi vars?',
        buttons: [{
                label: 'Delete',
                isPreferred: false,
                action: async () => {
                    try {
                        await ModuleFE_DiseaseProfile._v1.deleteReference({
                            diseaseProfileId: profileId,
                            referenceId: reference._id,
                        }).executeSync();
                    }
                    catch (err) {
                    }
                },
            }, {
                label: 'Cancel',
                isPreferred: true,
                action: voidFunction,
            }]
    });
};
const Field_References = (props) => {
    return _jsx(TS_PropRenderer.Horizontal, { label: 'References', children: _jsxs(LL_H_C, { className: 'e__disease-profile-references', children: [props.editable.item.referenceIds?.map(refId => {
                    const reference = ModuleFE_Reference.cache.unique(refId);
                    if (!reference) {
                        StaticLogger.logError('Field_References', `Could not find reference for id ${refId}`);
                        return;
                    }
                    return _jsxs(Grid, { className: 'e__disease-profile-reference', children: [props.editMode && _jsxs(LL_H_C, { className: 'e__disease-profile-reference__actions', children: [_jsx(ICONS.advisor_avn_edit.component, { className: 'edit', onClick: () => Preview_Reference.show(reference._id, true) }), _jsx(ICONS.bin.component, { className: 'delete', onClick: () => onReferenceDelete(props.editable.item._id, reference) })] }), _jsx(TS_PropRenderer.Horizontal, { label: 'Type', children: _jsx("div", { className: 'e__disease-profile__general-value', children: reference.type }) }), _jsx(TS_PropRenderer.Horizontal, { label: 'Label', children: _jsx("div", { className: 'e__disease-profile__general-value', children: resolveReferenceDisplay(reference) }) })] }, refId);
                }), props.editMode && _jsx(ICONS.advisor_v5_plus.component, { onClick: () => Preview_Reference.showNew(['book', 'article', 'upToDate'], (ref) => {
                        if (props.editable.item.referenceIds?.includes(ref._id))
                            return;
                        const editable = props.editable.editProp('referenceIds', []);
                        editable.updateArrayAt(ref._id);
                    }) })] }) });
};
export const Editor_DiseaseProfile_References = (props) => {
    const className = _className('e__disease-profile__references', props.editMode && 'edit-mode');
    return _jsx(FadeScrollWrapper, { className: className, children: _jsx(Grid, { children: _jsx(AwaitModules, { modules: [ModuleFE_Reference], children: _jsx(Field_References, { ...props }) }) }) });
};
//# sourceMappingURL=Editor_DiseaseProfile_References.js.map